import { sameDocument } from '../layout/editing'
import { t, type StaffLanguage } from './staffText'
import type { BranchDoc, NotLive } from './types'

/**
 * Whether two branch documents say the same thing: structural (sameDocument), with
 * a null list read as an empty one, because Go marshals an empty slice as null.
 */
export function sameBranchDoc(a: BranchDoc, b: BranchDoc): boolean {
  return sameDocument(filledBranchDoc(a), filledBranchDoc(b))
}

/** The document with every null list read as empty. */
export function filledBranchDoc(d: BranchDoc): BranchDoc {
  return {
    ...d,
    settings: { ...d.settings, openingHours: d.settings?.openingHours ?? [] },
    units: (d.units ?? []).map((u) => ({ ...u, instances: u.instances ?? [] })),
  }
}

/**
 * Whether this person may save a branch's setup or bring a version back (R8):
 * profiles.manage, and not limited to named branches.
 */
export function mayWriteSetup(identity: { permissions: readonly string[]; staff: { branchIds?: string[] } }): boolean {
  return identity.permissions.includes('profiles.manage') && !(identity.staff.branchIds ?? []).length
}

/**
 * Who published a version, in the words a screen shows: the joined display name,
 * else publishedBy itself (a deleted person's id, or migration 0029's sentence).
 */
export function publisherLabel(publishedBy?: string, publishedByName?: string): string {
  return publishedByName || publishedBy || ''
}

/** The line a profile save says when some of its branches could not go live; '' when all did. */
export function notLiveText(notLive: NotLive | undefined, lang: StaffLanguage): string {
  if (!notLive?.length) return ''
  return t('settings.live.notLive', lang, { names: notLive.map((b) => b.name || b.code).join(', ') })
}
